var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import "./dc-tabs.scss";
import { html, TemplateResult } from "lit-html";
import { unsafeHTML } from "lit-html/directives/unsafe-html";
import { component } from "haunted";
import classNames from "classnames";
import { isEmpty } from "GlobalShared/helpers/stringHelper";
export class TabSelectedEvent extends CustomEvent {
  constructor(detail) {
    super("tabSelected", { detail });
  }
}
const DEFAULTS = {
  queryPrefix: "tab",
  data: []
};
export const Component = (host) => {
  const props = {
    queryPrefix: host.queryPrefix !== void 0 ? host.queryPrefix : DEFAULTS.queryPrefix,
    data: host.data !== void 0 ? host.data : DEFAULTS.data,
    selectedTab: host.selectedTab,
    customClass: host.customClass
  };
  const getVisibleTabs = (tabs) => {
    return tabs.filter((tab) => !tab.isUnavailable);
  };
  const getTemplate = (tab) => {
    if (tab.template) {
      if (tab.template instanceof TemplateResult) {
        return tab.template;
      } else {
        return tab.template();
      }
    } else if (tab.tag) {
      const content = `<${tab.tag}></${tab.tag}>`;
      return html` ${unsafeHTML(content)} `;
    } else {
      return html``;
    }
  };
  const onTabSelect = (e) => {
    const tabName = e.currentTarget.dataset.tabName;
    host.dispatchEvent(new TabSelectedEvent({ selectedTab: tabName }));
  };
  const constantClasses = {
    "text-xs": true,
    "sm:text-sm": true,
    "md:text-base": true,
    "mr-4": true,
    "sm:mr-6": true
  };
  return html`
		<ul class="tab-navigation">
			${getVisibleTabs(props.data).map(
    (tab) => html`
					<li
						data-tab-name=${tab.name}
						class=${classNames(__spreadProps(__spreadValues({
      active: props.selectedTab === tab.name
    }, constantClasses), {
      [props.customClass]: !isEmpty(props.customClass)
    }))}
						@click=${onTabSelect}
						title=${tab.name}
					>
						${tab.label}
					</li>
				`
  )}
		</ul>
		${getVisibleTabs(props.data).map((tab) => html`<div class=${classNames("tab-panel", { active: tab.name === props.selectedTab })}>${getTemplate(tab)}</div>`)}
	`;
};
customElements.define(
  "dc-tabs",
  component(Component, {
    useShadowDOM: false,
    observedAttributes: []
  })
);
